import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { BrandLogo } from "@/components/Brand";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "long", timeStyle: "short" });

export default function PrivacyNoticePage() {
  const token = new URLSearchParams(window.location.search).get("t");
  const [n, setN] = useState(null);
  const [err, setErr] = useState("");
  const [read, setRead] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/public/privacy/${token}`).then((r) => setN(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);
  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/privacy/${token}/accept`, { read: true });
      setN((p) => ({ ...p, accepted_at: data.accepted_at }));
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen bg-[#f8faf5]">
      <header className="border-b bg-white px-5 py-3"><BrandLogo /></header>
      <main className="mx-auto max-w-2xl space-y-5 px-5 py-8" data-testid="privacy-page">
        {err && <p className="rounded-xl bg-red-50 p-4 text-sm text-red-700" data-testid="privacy-error">{err}</p>}
        {!n && !err && <Loader2 className="h-5 w-5 animate-spin" />}
        {n && (
          <>
            <div className="flex items-center gap-2"><ShieldCheck className="h-6 w-6 text-[#61a229]" /><h1 className="font-display text-2xl font-bold">Informativa dipendenti</h1></div>
            <p className="text-sm text-slate-500">Destinatario: <b data-testid="privacy-name">{n.name}</b></p>
            <div className="whitespace-pre-line rounded-2xl border bg-white p-5 text-sm leading-relaxed text-slate-700" data-testid="privacy-text">{n.text}</div>
            {n.accepted_at ? (
              <p className="flex items-center gap-2 rounded-2xl bg-[#a2ca6b]/20 p-4 text-sm font-semibold text-[#2f5410]" data-testid="privacy-accepted">
                <CheckCircle2 className="h-5 w-5" /> Presa visione confermata il {fmt(n.accepted_at)}
              </p>
            ) : (
              <div className="space-y-4 rounded-2xl border bg-white p-5">
                <label className="flex items-start gap-3 text-sm">
                  <Checkbox checked={read} onCheckedChange={(v) => setRead(!!v)} data-testid="privacy-read-checkbox" />
                  Dichiaro di aver ricevuto, letto e compreso l'informativa.
                </label>
                <Button onClick={accept} disabled={!read || busy} className="w-full rounded-full bg-[#61a229] hover:bg-[#528a22]" data-testid="privacy-accept-button">
                  {busy && <Loader2 className="h-4 w-4 animate-spin" />} Confermo la presa visione
                </Button>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}
